import { AssetTypes, getAssetRatio } from '../../hooks/studioContext/CMSParams';
import {
  PAGE_HEIGHT_PARAM,
  PAGE_WIDTH_PARAM,
} from '../../web-stories-wp/units/src/constants';

export const TEMPLATE_CARD_WIDTH = 158;

const DEFAULT_TEMPLATE_RATIO = getAssetRatio(AssetTypes.StoryThumbnail);
const DEFAULT_PREVIEW_HEIGHT = Math.round(
  TEMPLATE_CARD_WIDTH / DEFAULT_TEMPLATE_RATIO
);

const getTemplateRatioFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const width = parseFloat(searchParams.get(PAGE_WIDTH_PARAM));
  const height = parseFloat(searchParams.get(PAGE_HEIGHT_PARAM));

  if (width > 0 && height > 0) {
    return width / height;
  }

  return 0;
};

const getTemplateRatio = (assetType) => {
  const ratioFromUrl = getTemplateRatioFromUrl();

  // Studio routes can carry the live template ratio in the URL even when the
  // surrounding asset-type context still resolves to a broader bucket.
  if (ratioFromUrl > 0) {
    return ratioFromUrl;
  }

  return getAssetRatio(assetType);
};

export const getTemplateCardSize = (assetType) => {
  const ratio = getTemplateRatio(assetType);
  const previewHeight =
    ratio > 0
      ? Math.round(TEMPLATE_CARD_WIDTH / ratio)
      : DEFAULT_PREVIEW_HEIGHT;

  return {
    width: TEMPLATE_CARD_WIDTH,
    height: previewHeight,
    containerHeight: previewHeight,
  };
};
